<template>
  <st-header v-if="header" :header="header"></st-header>
</template>

<script>
import { mapState } from "vuex";
import StHeader from "../../main/header/st-header.vue";

export default {
  components: { StHeader },
  computed: {
    ...mapState(["header"]),
  },
};
</script>
